// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7L6XK","textarea":"styles_textarea__322Kt"};